import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-book",
  "use": "icon-book-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-book\"><defs><style></style></defs><path d=\"M896 128v832H224c-53.024 0-96-42.976-96-96s42.976-96 96-96h608V0H192C121.6 0 64 57.6 64 128v768c0 70.4 57.6 128 128 128h768V128h-64z\" /><path d=\"M224.064 832H224c-17.664 0-32 14.336-32 32s14.336 32 32 32h607.968v-64H224.064z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol